import TeamList from './team-list.component';
import FetchMyTeams from '../../resolver/fetch-my-teams.component';
import './my-teams.component.scss';

const MyTeams = () => <FetchMyTeams>{teams => <TeamList teams={teams} />}</FetchMyTeams>;

export default MyTeams;
